<template>
	<inertia-head title="TRC COUPLES BLOGS" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">TRC COUPLES BLOGS</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						The Truly Rich Club's couple-focused content—often appearing in blogs like "One True Love"—provides spiritual and financial guidance for couples to achieve abundance together.
					</h2>
				</div>
			</div>
		</div>
	</div>

	<div class="content mt-5">
		<div v-if="trcCouplesBlogs.data.length > 0" class="row pb-4 justify-content-center">
			<!--START Posts -->
			<div v-for="blog in trcCouplesBlogs.data" :key="blog.couple_blog_uuid" class="col-xl-10 col-lg-10 col-md-10 mt-5">
				<div>
					<div
						class="overflow-hidden rounded mb-3 bg-image text-center"
						style="height: 200px;"
					>
					<img :src="blog.blog_image_url" class="img-fluid w-100 h-100 img-obj-fit" alt="blog image">
					</div>
				</div>
				<div class="p-3 pt-0">
					<p class="mb-1 h2"><inertia-link :href="'/member/trc-couple/blog/details/'+blog.couple_blog_uuid" class="text-dark">{{ blog.blog_title }}</inertia-link></p>
					<div class="fs-sm fw-medium text-muted mb-2">
						<span class="me-3 fs-xs">
							<i class="fa fa-fw fa-calendar-alt opacity-50 me-1"></i>
							{{ blog.date_start }}
						</span>
					</div>
				</div>
				<div class="p-3 pt-0">
					<div style="white-space: pre; white-space:break-spaces;overflow: hidden;" v-html="blog.short_desc"></div>
					<p class="mt-2"><inertia-link :href="'/member/trc-couple/blog/details/'+blog.couple_blog_uuid">Read More...</inertia-link></p>
				</div>
			</div>
			<nav class="d-flex justify-content-between align-items-center push">
				<inertia-link
					v-if="trcCouplesBlogs.prev_page_url"
					:href="trcCouplesBlogs.prev_page_url"
					class="btn btn-secondary"
					:class="{ disabled: !trcCouplesBlogs.prev_page_url }"
				>
					<i class="fa fa-arrow-left opacity-50 me-1"></i>
					<span>Prev</span>
				</inertia-link>
				<inertia-link
					v-if="trcCouplesBlogs.next_page_url"
					:href="trcCouplesBlogs.next_page_url"
					class="btn btn-secondary"
					:class="{ disabled: !trcCouplesBlogs.next_page_url }"
				>
					<span>Next</span>
					<i class="fa fa-arrow-right opacity-50 ms-1"></i>
				</inertia-link>
			</nav>
			<hr class="d-xl-none" />
			<!-- END Posts -->

		</div>
		<div v-else>
			<div class="block block-rounded">
				<div class="block-content block-content-full">
					<p class="m-0 h4 text-danger text-center">No Blogs Found...</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', window.gtag_id);
	
import axios from 'axios'
import { debounce } from 'lodash'
import { onMounted, ref, reactive } from 'vue'
import AuthLayout from '../../../Layouts/AuthLayout'

export default {
	layout: AuthLayout,
	props: {
		trcCouplesBlogs: Object,
	},
	setup(props) {
		const modal 			= ref(null);
		let trcCouplesBlogs 		= ref(props.trcCouplesBlogs);

		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')

		})

		
		return {
			modal,
			trcCouplesBlogs
		}
	},
}
</script>
